import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    item: {
      marginBottom: '32px',
    },
    title: {
      padding: theme.spacing(12, 0), // 上下|右左, 上|右左|下, 上|右|下|左
      textAlign: 'center',
      width: '79%',
      maxWidth: '79%',
      margin: 'auto',
      // backgroundColor: '#F00',
    },
    text: {
      padding: theme.spacing(0),
      width: '62%',
      maxWidth: '62%',
      margin: 'auto',
      // backgroundColor: '#0F0',
    },
    offset: theme.mixins.toolbar,
  })
);

function About() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <Typography variant="h5" className={classes.title}>
            会社概要
          </Typography>

          <Typography variant="subtitle1" className={classes.text}>
            商号 しいね産業 (株)
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            SHIINE-Sangyou, Inc.
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            設立 昭和 45年 2月
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            資本金 7,700万円
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            所在地 〒963-0534
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            福島県 郡山市 日和田町 大窪49
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            代表取締役社長 椎根正裕
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            従業員数 20名 主な事業内容 屋根資材卸問屋業, 屋根工事,
            太陽光発電の設置
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default About;
